import { Flex } from '@chakra-ui/react';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import moment from 'moment';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

import FormCadastrarEditarVendas from '../../../../../components/forms/FormCadastrarEditarVendas';
import { useGetSaleWithId } from '../../../../../services/queryClient/wrapperHooks/useGetSaleById';

export default function EditarVenda() {
	const { setters } = useContext(SidebarHelpContext);

	const { setDataSidebar } = setters;

	const { id: saleId } = useParams<any>();

	const { data: SaleData } = useGetSaleWithId(saleId);

	const [initialState, setInitialState] = useState<any>();
	const [autocompleteAdditionalData, setAutocompleteAditionalData] =
		useState<any>();

	const helpEditarVendas: ISidebarHelp = useMemo(
		() => ({
			title: 'Editar Vendas',
			firstParagraph:
				'Para editar uma venda, selecione a Data desejada e entre com os dados dos demais campos. Cada venda deve ser associada a hierarquia comercial responsável pela venda.',
			secondParagraph:
				'Para cadastrar novos canais de venda e zonas de venda, acesse no menu Cadastros > Comercial > Hierarquia. Para cadastrar uma venda referente a um novo cliente, siga o fluxo de Importar Vendas.',
			thirdParagraph:
				'Para cadastrar uma venda referente a um novo produto, cadastre o produto previamente em Cadastros > Produto > Produtos.',
			firstLink: URL_CT360,
			secondLink: URL_FALE_CONOSCO,
		}),
		[]
	);

	useEffect(() => {
		setDataSidebar(helpEditarVendas);
	}, [helpEditarVendas, setDataSidebar]);

	useEffect(() => {
		if (SaleData) {
			setAutocompleteAditionalData({
				product: SaleData?.produto,
				family: SaleData?.produto?.familia,
				sub_family: SaleData?.produto?.sub_familia,
				product_model: SaleData?.produto?.modelo_produto,
				client: SaleData?.cliente_relacionado,
			});

			setInitialState({
				nf: SaleData?.nf,
				sequencia_nf: SaleData?.sequencia_nf,
				data_venda: moment(SaleData?.data_venda, 'YYYY-MM-DD').format(
					'YYYY-MM-DD'
				),
				codigo_pedido: SaleData?.codigo_pedido,
				canal_venda_id: SaleData?.hierarquia_comercial?.canal_venda?.id,
				zona_venda_id: SaleData?.hierarquia_comercial?.zona_venda?.id,
				mercado_id: SaleData?.hierarquia_comercial?.mercado?.id,
				forca_venda_id: SaleData?.hierarquia_comercial?.forca_venda?.id,
				membro_id: SaleData?.hierarquia_comercial?.membro?.id,
				cliente_id: SaleData?.cliente_relacionado?.id,
				familia_id: SaleData?.produto?.familia?.id,
				sub_familia_id: SaleData?.produto?.sub_familia?.id,
				modelo_produto_id: SaleData?.produto?.modelo_produto?.id,
				produto_id: SaleData?.produto?.id,
				quantidade: SaleData?.quantidade,
				receita_bruta: SaleData?.receita_bruta
					? Number(SaleData?.receita_bruta?.toFixed(2))
					: 0,
			});
		}
	}, [SaleData]);

	return (
		<Flex
			direction='column'
			pt={{ sm: '125px', lg: '75px' }}
		>
			<FormCadastrarEditarVendas
				initialState={initialState}
				saleId={saleId}
				autocompleteAdditionalData={autocompleteAdditionalData}
			/>
		</Flex>
	);
}
